module.exports = __webpack_public_path__ + "static/Grafika5-231230f80c3935063a2f9f25ffc653b3.png";